var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransitionGroup',{attrs:{"name":"height-fade","tag":_vm.tag},on:{"enter":_vm.enter,"afterEnter":_vm.afterEnter,"leave":_vm.leave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }